export default "__VITE_ASSET__BvLsqSWk__"